import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConnectivityCatalogEntry } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-connectivity-table',
  templateUrl: './connectivity-table.component.html',
  styleUrls: ['./connectivity-table.component.scss']
})
export class ConnectivityTableComponent implements OnInit {

  @Input() loadingTable: boolean = false;
  @Input() catalogEntryList: ConnectivityCatalogEntry[]
  @Input() loadingLines: number[] = [1, 2, 3];

  @Output() editEntry: EventEmitter<ConnectivityCatalogEntry> = new EventEmitter();
  @Output() editEntryDocuments: EventEmitter<ConnectivityCatalogEntry> = new EventEmitter();
  @Output() deleteEntry: EventEmitter<ConnectivityCatalogEntry> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public openEditModal(entry: ConnectivityCatalogEntry) {
    this.editEntry.emit(entry);
  }

  public openDeleteModal(entry: ConnectivityCatalogEntry) {
    this.deleteEntry.emit(entry);
  }

  public openEditDocumentsModal(entry: ConnectivityCatalogEntry) {
    this.editEntryDocuments.emit(entry);
  }
}
